export default __webpack_public_path__ + "static/media/suisse.86ee512a.svg";